import { sharedInitialValues } from '../shared/sharedInitialValues';

export const initialValues = (values = {}) => ({
    gender: null,
    receiptPlan: 'own',
    selectedMedications: [],
    isPregnat: null,
    additionalDiseases: null,
    additionalDiseasesDescription: null,
    hasCare: null,
    carePerson: null,
    hasOperations: null,
    operationsDescription: null,
    operationsYears: null,
    hasOperationComplications: null,
    drugWasUsed: null,
    hasDrugAllergies: null,
    whatDrugsHasAllergies: '',
    permamentMedication: '',
    hasPermamentMedications: null,
    importantInformation: '',
    uploadedFile: [],
    ...sharedInitialValues(values),
});
